export const OOS_RECOVERY_OPTIONS = {
  STORE_PICKUP_OPTION: 'STORE_PICKUP_OPTION',
  STH_DELIVERY_OPTION: 'STH_DELIVERY_OPTION',
  BODFS_DELIVERY_OPTION: 'BODFS_DELIVERY_OPTION',
} as const;

export type TOosRecoveryOption = keyof typeof OOS_RECOVERY_OPTIONS;

export enum FLOW_TYPES {
  BOPIS_OOS_RECOVERY = 'BOPIS_OOS_RECOVERY',
  EDIT_PICKUP_LOCATION = 'EDIT_PICKUP_LOCATION',
  EDIT_DELIVERY_ADDRESS = 'EDIT_DELIVERY_ADDRESS',
}

/**
 * Copy for the OOS "Find a Replacement" (Rec Engine) flow.
 * Gated behind the `enableBopisOutOfStockReplacement` feature switch.
 */
export const FIND_A_REPLACEMENT_COPY = {
  BUTTON: 'Find a Replacement',
  DRAWER_TITLE: 'Find a Replacement',
  SIMILAR_ITEMS_HEADING: 'Similar Items at Your Pickup Location',
  OUT_OF_STOCK_BADGE: 'Out of Stock',
  ADD_TO_CART: 'Add to Cart',
  ADDED_TO_CART: 'Added to Cart',
  VIEW_CART: 'View Cart',
  VIEW_ORDER_DETAILS: 'View Order Details',
  CART_ERROR: 'There was a problem adding your item. Please try again.',
} as const;

/**
 * Number of mocked recommendations rendered in the replacement drawer until the
 * Rec Engine API (via OMM orchestration) is integrated. MOCK-ONLY — remove/replace
 * when the recommendations API is wired up.
 */
export const MOCK_REPLACEMENT_COUNT = 3;
